import React, { useContext } from "react";
import { Box, Button, Paper, Stack, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, Tooltip } from "@mui/material";
import Application from "../../../components/application";
import MyLabel from "../../../components/myLabel";
import MyPanel from "../../../components/myPanel";
import MyLoading from "../../../components/myLoading";
import { useEffect, useState } from "react";
import MySearch from "../../../components/mySearch";
import MyButton from "../../../components/myButton";
import useCursoPermissao from "../../../hooks/useCursoPermissao";
import { useNavigate, useParams } from "react-router-dom";

import DeleteIcon from '@mui/icons-material/Delete';
import Styles from "./styles";
import MyCheckbox from "../../../components/myCheckbox";
import TELAS from "../../../constants/telas";
import { AuthContext } from "../../../contexts/auth";
import TELA_ACOES from "../../../constants/telaAcoes";
import permissaoTelas from "../../../utils/permissaoTelas";


const PAGINA = {
    aplicacao: 'SisPalo - Colaborador',
    funcionalidade: 'Cursos',
    tela: TELAS.CURSOS,
    acoes: [TELA_ACOES.Alterar]
}

const CustomTabPanel = (props) => {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {
            value === index ?
                children
            :   
                <></>
        }
      </div>
    );
  }
  
  
const a11yProps = (index)  =>{
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
}

const TabOutros = ({styles, states}) => {

    return (
        <Box sx={{marginTop:'20px'}}>
            <Box >
                <MyLabel sx={styles.subtitle} text={`Outras permissões`} />
            </Box>
            <MyCheckbox
                label='Lider'
                checked={states.lider.value}
                onChange={()=> states.lider.set(!states.lider.value)}
            />
        </Box>
        
    )
}


const TabArea = ({label, permissoes, permissoesSelecionadas, styles}) => {

    const handlerRemove = (id) => {
            let _permi = permissoesSelecionadas.value.filter(item => item.id !== id)
            permissoesSelecionadas.set(_permi)
    }

    return (
        <Box sx={{marginTop:'20px'}}>
            <MySearch 
                getOptions = {permissoes.set}

                label={label}
                values={permissoes.value}
                valuesSelects={permissoesSelecionadas.value}
                onSelect={(select)=>{
                    if (permissoesSelecionadas.value.filter(e => e.name === select.name).length <= 0) {
                        permissoesSelecionadas.set([...permissoesSelecionadas.value, select])
                    }
                }} 
                />
            <Box sx={{marginTop: '10px'}}>
                <Box >
                    <MyLabel sx={styles.subtitle} text={`Selecionados(as)`} />
                </Box>
                <Box>
                    <TableContainer component={Paper} sx={{maxHeight:'25vh'}}>
                        <Table size="small"  sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead >
                            <TableRow >
                                <TableCell sx={styles.tableHead}> Nome</TableCell>
                                <TableCell sx={styles.tableHead}> </TableCell>
                            </TableRow>
                            </TableHead>
                            <TableBody>
                            {permissoesSelecionadas.value.sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1).map((row, key) => (
                                <TableRow
                                    
                                    key={key}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                <TableCell component="th" scope="row" >
                                    {row.name}
                                </TableCell>
                                <TableCell sx={{width:'20px'}} component="th" scope="row" >
                                    <Tooltip title="Remover" placement="bottom" arrow>
                                        <Button sx={{height:'20px'}} color='error'  onClick={()=>handlerRemove(row.id)}><DeleteIcon /></Button>
                                    </Tooltip> 
                                </TableCell>
                                </TableRow>
                            ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Box>
        </Box>
    )
}

const CursoPermissao = () => {
    const states = useCursoPermissao()
    const { idCurso } = useParams()    
    const [activeTab, ssetActiveTab] = useState(0);
    const {permissaoUsuario} = useContext(AuthContext); /* permissão para telas*/   
    const navigate = useNavigate()

    let styles = Styles()

    const handleChange = (event, newValue) => {
        ssetActiveTab(newValue);
    };

    useEffect(()=>{
        if (states.curso.value?.id){
           states.buscarPermissaoCurso.set()
        }

    }, [states.curso.value])

    
    useEffect(()=>{
        /* permissão para telas*/
        if (permissaoTelas(permissaoUsuario,TELA_ACOES.Alterar, PAGINA)){
            if (idCurso && idCurso !== ''){
               states.curso.set(idCurso)
            }
        }
        else {
            navigate('/gestor/dashboard')
        }



    }, [])

    let minhasTabs = [
        {label:'Coligadas',  permissoes: states.coligadas, permissoesSelecionadas: states.coligadasSelecionada},
        {label:'Postos',  permissoes: states.postos, permissoesSelecionadas: states.postosSelecionados},
        {label:'Coordenador',  permissoes: states.supervisores, permissoesSelecionadas: states.supervisoresSelecionados},
        {label:'Função',  permissoes: states.funcoes, permissoesSelecionadas: states.funcoesSelecionados},
        {label:'Colaborador',  permissoes: states.funcionarios, permissoesSelecionadas: states.funcionariosSelecionados},
    ]


    return(
        <Application>
            <MyPanel>
                <MyLoading render={states.submit.value}/>
                <Stack spacing={5}>
                    <Box sx={{display:'flex', justifyContent:'space-between'}}>
                        <MyLabel sx={styles.title} component='h1' text = {`Permissões de curso: ${states.nome.value}`}/>
                        <MyButton color='warning' onClick={()=>navigate('/gestor/cursos')} variant='contained' text='Voltar'/>
                    </Box>
                    <Box>
                        <Box>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <Tabs value={activeTab} onChange={handleChange} aria-label="basic tabs example">
                                    {
                                        minhasTabs.map((item, key) => <Tab key={key} label={item.label} {...a11yProps(key)} />)
                                    }
                                    <Tab label="Outros" {...a11yProps(minhasTabs.length)} />
                                </Tabs>
                                </Box>
                                {
                                    minhasTabs.map((item, key)=>{

                                        return (
                                            <CustomTabPanel key={key} value={activeTab} index={key}>
                                                <TabArea 
                                                    label={item.label}
                                                    permissoes={item.permissoes}
                                                    permissoesSelecionadas={item.permissoesSelecionadas}
                                                    styles={styles}
                                                />
                                            </CustomTabPanel>

                                        )
                                    })

                                }
                                <CustomTabPanel value={activeTab} index={minhasTabs.length}>
                                    <TabOutros styles={styles} states={states} />
                                </CustomTabPanel>
                            </Box>

                    </Box>
                    <Box>
                        <MyButton onClick={states.submit.set} variant='contained' text='Salvar'/>
                    </Box>
                </Stack>
            </MyPanel>
        </Application>
    )
}
export default CursoPermissao;